// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/trial'
const state = {
}

const mutations = {
}

const actions = {

	/**
     * 후유 트라이얼 계정 생성
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
	// eslint-disable-next-line no-unused-vars
    async registerTrialUserAccount ({commit}, payload) {
        return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/user/account`, payload)
    },

	/**
	 * 트라이얼 유저 계정 해피민트 잔액 조회 ( 해피민트 회기 차감을 위한 )
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async isBalanceCheckAvailable ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `/dms/v1/user/trial/payment/balance/check`, payload)
	},

	/**
	 * 트라이얼 유저 계정 결제하기
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async executePayment ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `/dms/v1/user/trial/payment/deduct`, payload)
	},

	/**
	 * 직접 티켓 구매 (이용권 종료 이후)
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async continueDirectTicket ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `/dms/v1/user/trial/payment/direct/ticket`, payload)
	}

}

export default { state, mutations, actions }
